export const NAV_LINKS = [
  { name: "Home", path: "/" },
  { name: "Our Story", path: "/about" },
  { name: "Hair", path: "/services-hair" },
  { name: "Laser & Skin", path: "/services-laser" },
  { name: "Gallery", path: "/gallery" },
  { name: "Reviews", path: "/testimonials" },
  { name: "Contact", path: "/contact" },
];

export const IMG = {
  hero: "/assets/hero.webp",
  tools: "/assets/img/tools.webp",
  interior1: "/assets/img/interior1.webp",
  interior2: "/assets/img/interior2.webp",
  interior3: "/assets/img/interior3.webp",
  hair1: "/assets/img/hair1.webp",
  hair2: "/assets/img/hair2.webp",
  hair3: "/assets/img/hair3.webp",
  hair4: "/assets/img/hair4.webp",
  hair5: "/assets/img/hair5.webp",
  hair6: "/assets/img/hair6.webp",
  hair7: "/assets/img/hair7.webp",
  portrait1: "/assets/img/portrait1.webp",
  portrait2: "/assets/img/portrait2.webp",
  portrait3: "/assets/img/portrait3.webp",
  laser1: "/assets/img/laser1.webp",
  laser2: "/assets/img/laser2.webp",
  laser3: "/assets/img/laser3.webp",
  spa1: "/assets/img/spa1.webp",
  spa2: "/assets/img/spa2.webp",
  spa3: "/assets/img/spa3.webp",
  spa4: "/assets/img/spa4.webp",
  product: "/assets/img/product.webp",
};

export const HAIR_SERVICES = [
  { name: "Hair Spa", duration: "45–60 min", img: "/assets/img/svc-hairspa.webp", desc: "A slow scalp ritual — massage, steam and deep nourishment." },
  { name: "Hair Wash, Cut & Blow Dry", duration: "45–60 min", img: "/assets/img/svc-washcut.webp", desc: "The full reset: cleanse, precision cut, polished finish." },
  { name: "Hair Cut", duration: "30–45 min", img: "/assets/img/svc-haircut.webp", desc: "A considered cut, shaped to your features." },
  { name: "Root Touch-Up", duration: "60–90 min", img: "/assets/img/svc-roots.webp", desc: "Seamless regrowth coverage, matched exactly to your shade." },
  { name: "Full Hair Color", duration: "90–120 min", img: "/assets/img/svc-fullcolor.webp", desc: "Rich, even colour from root to tip." },
  { name: "Highlights", duration: "2–3 hrs", img: "/assets/img/svc-highlights.webp", desc: "Hand-placed foils for natural, light-catching dimension." },
  { name: "Balayage", duration: "2.5–3.5 hrs", img: "/assets/img/svc-balayage.webp", desc: "Hand-painted lightness that grows out gracefully." },
  { name: "Perm", duration: "2–2.5 hrs", img: "/assets/img/svc-perm.webp", desc: "Soft, modern texture with movement that lasts." },
  { name: "Hair Smoothening", duration: "2–3 hrs", img: "/assets/img/svc-smoothening.webp", desc: "Frizz calmed, shine restored, for months." },
  { name: "Hair Treatments", duration: "30–45 min", img: "/assets/img/svc-treatments.webp", desc: "Targeted repair for stressed or damaged hair." },
  { name: "Keratin Treatment", duration: "2–3 hrs", img: "/assets/img/svc-keratin.webp", desc: "Glass-like smoothness with weightless movement." },
  { name: "Hair Botox", duration: "1.5–2.5 hrs", img: "/assets/img/svc-botox.webp", desc: "A deep-conditioning filler for tired, porous hair." },
];

export const LASER_SERVICES = [
  { name: "Laser Hair Removal", duration: "15–60 min", img: "/assets/img/svc-lhr.webp", desc: "Medical-grade laser, calibrated to your skin — timing varies by treatment area." },
  { name: "Microneedling", duration: "45–75 min", img: "/assets/img/svc-microneedling.webp", desc: "Collagen-inducing micro-channels for firmer, smoother skin." },
  { name: "Hair Restoration Treatment", duration: "45–60 min", img: "/assets/img/svc-hairrestoration.webp", desc: "Scalp-focused therapy to support stronger growth." },
  { name: "Chemical Peel", duration: "30–45 min", img: "/assets/img/svc-peel.webp", desc: "Controlled exfoliation for clarity and renewed glow." },
  { name: "Janssen Brightening Facial", duration: "60–75 min", img: "/assets/img/svc-janssen.webp", desc: "A professional brightening protocol for dull, uneven tone." },
  { name: "LED Light Therapy", duration: "20–30 min", img: "/assets/img/svc-led.webp", desc: "Calming light wavelengths that support skin repair." },
  { name: "Lymphatic Drainage Massage", duration: "45–60 min", img: "/assets/img/svc-lymphatic.webp", desc: "A gentle, rhythmic technique to de-puff and detoxify." },
];

export const TESTIMONIALS = [
  { quote: "I've never felt more comfortable in a laser studio. It genuinely feels like a five-star spa.", name: "Client", meta: "Brampton", service: "Laser & Skin" },
  { quote: "My colour has never looked this healthy. S & Z pays attention to details other salons skip.", name: "Client", meta: "Brampton", service: "Colour & Balayage" },
  { quote: "Professional, private, and precise — exactly what I didn't know I was missing.", name: "Client", meta: "Brampton", service: "Signature Cut" },
  { quote: "No waiting, no noise, no rush. Just an hour that belongs entirely to you.", name: "Client", meta: "Brampton", service: "Medi-Facial" },
  { quote: "The balayage grew out so softly I forgot it wasn't my natural colour.", name: "Client", meta: "Brampton", service: "Balayage" },
  { quote: "They explained every step of my laser plan. I felt informed, never sold to.", name: "Client", meta: "Brampton", service: "Laser Hair Removal" },
];

export const GALLERY_ITEMS = [
  { src: IMG.hair1, category: "Hair", title: "The Ritual Wash" },
  { src: IMG.hair6, category: "Hair", title: "Precision in Profile" },
  { src: IMG.hair2, category: "Colour", title: "Lived-In Dimension" },
  { src: IMG.hair7, category: "Colour", title: "Hand-Painted Light" },
  { src: IMG.hair4, category: "Hair", title: "The Finishing Touch" },
  { src: IMG.laser1, category: "Skin & Laser", title: "Clinical Calm" },
  { src: IMG.laser2, category: "Skin & Laser", title: "The Medi-Facial" },
  { src: IMG.spa3, category: "Skin & Laser", title: "Quiet Renewal" },
  { src: IMG.hair3, category: "Colour", title: "Golden Hour Balayage" },
];

export const BEFORE_AFTER = [
  { id: "laser-hair-removal", label: "Laser Hair Removal", caption: "Six sessions, full course", image: IMG.laser2 },
  { id: "skin-rejuvenation", label: "Skin Rejuvenation", caption: "Three sessions, eight weeks", image: IMG.spa3 },
  { id: "pigmentation-correction", label: "Pigmentation Correction", caption: "Two sessions, six weeks", image: IMG.laser1 },
];

export const STANDARDS = [
  { title: "Certified Specialists", desc: "Every treatment is performed by trained, certified professionals who take your results as seriously as you do." },
  { title: "Premium Product Lines", desc: "We use only professional-grade products and medical-grade equipment — nothing diluted, nothing generic." },
  { title: "Private Treatment Suites", desc: "No open floor, no distractions — just you, in a calm space designed for comfort." },
  { title: "By Appointment Only", desc: "Every visit is unhurried. We see one client at a time, never a queue." },
];

export const ADDRESS = "70 Chesterwood Cres Unit A, Brampton, ON L6Y 0Z4";
export const PHONE = "(647) 773-5359";
export const PHONE_TEL = "+16477735359";
// Single source for the studio's hours. `time` is the display string used by
// the Contact page card and the footer; `opens`/`closes` (24h) feed the
// LocalBusiness schema markup generated at build time. Tuesday is closed.
export const HOURS = [
  { day: "Monday", time: "10:00 AM — 8:00 PM", opens: "10:00", closes: "20:00" },
  { day: "Tuesday", time: "Closed" },
  { day: "Wednesday", time: "10:00 AM — 8:00 PM", opens: "10:00", closes: "20:00" },
  { day: "Thursday", time: "10:00 AM — 8:00 PM", opens: "10:00", closes: "20:00" },
  { day: "Friday", time: "10:00 AM — 8:00 PM", opens: "10:00", closes: "20:00" },
  { day: "Saturday", time: "10:00 AM — 7:00 PM", opens: "10:00", closes: "19:00" },
  { day: "Sunday", time: "11:30 AM — 6:00 PM", opens: "11:30", closes: "18:00" },
];
export const INSTAGRAM_URL = "https://www.instagram.com/sophia_hair_salon/";
export const BOOKING_URL = "https://sophiahairsalonspa.setmore.com";
